import { render, staticRenderFns } from "./DestinationIdx.vue?vue&type=template&id=0dd63178"
import script from "./DestinationIdx.vue?vue&type=script&lang=js"
export * from "./DestinationIdx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports